import moment from "moment";

// Console Logger Interceptor - Captures all console logs and sends to API on error
class ConsoleLogger {
  constructor() {
    this.logs = [];
    this.maxLogs = 1000;
    this.apiEndpoint = process.env.REACT_APP_API_URL + "auth/sendlogs";

    // Store original console methods
    this.originalLog = console.log;
    this.originalError = console.error;
    this.originalWarn = console.warn;
    this.originalInfo = console.info;
    this.originalDebug = console.debug;
  }

  // Intercept console methods
  interceptConsole() {
    console.log = (...args) => {
      this.storeLog("log", args);
      this.originalLog.apply(console, args);
    };

    console.error = (...args) => {
      this.storeLog("error", args);
      this.originalError.apply(console, args);
    };

    console.warn = (...args) => {
      this.storeLog("warn", args);
      this.originalWarn.apply(console, args);
    };

    console.info = (...args) => {
      this.storeLog("info", args);
      this.originalInfo.apply(console, args);
    };

    console.debug = (...args) => {
      this.storeLog("debug", args);
      this.originalDebug.apply(console, args);
    };
  }

  // Safe JSON stringify that handles circular references
  safeStringify(obj) {
    const seen = new WeakSet();

    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return "[Circular]";
        }

        seen.add(value);
      }

      return value;
    });
  }

  storeLog(level, args) {
    const timestamp = moment().toISOString(true);

    const logEntry = {
      timestamp,
      level,
      args,
      url: window.location.href,
    };

    this.logs.push(logEntry);

    // Keep memory in check
    if (this.logs.length > this.maxLogs) {
      this.logs.shift();
    }
  }

  getLogs() {
    return [...this.logs];
  }

  clearLogs() {
    this.logs = [];
  }

  async sendLogsToAPI() {
    if (this.logs.length === 0) {
      this.originalLog("No logs to send");
      return;
    }

    try {
      const response = await fetch(this.apiEndpoint, {
        method: "POST",

        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },

        body: this.safeStringify({
          logs: this.getLogs(),
          timestamp: moment().toISOString(true),
          userAgent: navigator.userAgent,
        }),
      });

      if (!response.ok) {
        throw new Error(`API responded with status ${response.status}`);
      }

      this.originalLog("Logs sent successfully to API");
      return response.json();
    } catch (error) {
      this.originalError("Failed to send logs to API:", error);
      throw error;
    }
  }
}

const consoleLogger = new ConsoleLogger();
export default consoleLogger;
